import { Link, useLocation, useNavigate } from 'react-router-dom'
import './styles/assistancesinfo.css'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Confirm from '../components/confirm'
import { MdDeleteOutline } from "react-icons/md"
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { useEffect, useState } from 'react'
import { collection, deleteDoc, doc, getDoc, getDocs, increment, query, updateDoc } from 'firebase/firestore'
import { db } from '../assets/connections'

const AssistancesInfo = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const id = location.state ? location.state.id : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        regRef: null,
        historial: [],
        loading: true,
        show: false,
        date: new Date(),
        currItem: null
    })

    const [ selDate, setSelDate ] = useState("")

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
                            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #56d600;'></div>"
                          : status == "warning" ?
                            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                          : status == "error" ?
                            "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" + 
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #c20000;'></div>"
                          : ""
        
        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Funcion que obtiene la direccion de la bd del historial de la clase
    const getHistory = async () => {
        await getDoc(doc(doc(db, ref), "Historial", id)).then(r => {
            getHistoryRegs(r.ref) //Obtenemos la referencia del historial de la clase
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener la informacion", "error")
            }, 100)
        })
    }
    //Funcion que obtiene las clases que se han impartido de una seleccionada clase
    const getHistoryRegs = async (regRef) => {
        var aux = []
        await getDocs(query(collection(regRef, "Historial"))).then(docs => {
            docs.docs.map(v => {
                const d = v.data()
                if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
                    aux.push({
                        id: v.id,
                        nombre_clase: d.nombre_clase,
                        fecha_clase: d.fecha_clase,
                        hora_clase: d.hora_clase,
                        alumnos_clase: d.alumnos_clase,
                        jugadores_reposicion: d.jugadores_resposicion ? d.jugadores_reposicion : []
                    })
                } else {
                    aux.push({
                        id: v.id,
                        nombre_clase: d.nombre_clase,
                        fecha_clase: d.fecha_clase,
                        hora_clase: d.hora_clase,
                        alumnos_clase: d.jugadores_registrados
                    })
                }
            })

            setVariables(prev => ({
                ...prev,
                regRef: regRef.path,
                historial: aux,
                loading: false
            }))

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getHistory()
        }
    }, [])

    if(variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if(!variables.loading)
    return (
        <div className='mainAssistancesInfo'>

            <Snack />

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>REGISTROS</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -40,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <p style={{
                fontFamily: fontType.text,
                fontWeight: "bold",
                textAlign: "center"
            }}>SELECCIONAR FECHA</p>
            <input
                value={variables.date}
                type='date'
                style={{
                    fontFamily: fontType.text,
                    padding: 5,
                    marginTop: 10,
                    borderRadius: 5,
                    borderWidth: 2,
                    borderColor: "#DDD",
                    borderStyle:"solid",
                    marginBottom: 5
                }}
                onChange={e => {
                    const date = new Date(e.target.value)
                    var aux = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 1)

                    setVariables(prev => ({
                        ...prev,
                        show: false,
                        date: date
                    }))
                    setSelDate(aux)
                }} 
            />
            <p style={{
                fontFamily: fontType.text,
                fontWeight: "bold"
            }}>{selDate}</p>

            <div className='contAssistances'>

                {
                    selDate ?
                        variables.historial.filter(v => v.fecha_clase === selDate).map((v, i) => {
                            return (
                                <div className='class'>
                                    <Link to={"/controlpanel/assistances/info/reg"} state={{
                                        regId: v.id,
                                        ref: ref,
                                        id: id,
                                        regRef: variables.regRef,
                                        academia: academia
                                    }} className='contInfo'>
                                        <p style={{
                                            fontFamily: fontType.title
                                        }} className='nombre'>{v.nombre_clase}</p>
                                        <p style={{
                                            fontFamily: fontType.text
                                        }} className='fecha'>{v.fecha_clase} | {v.hora_clase}</p>
                                    </Link>
                                </div>
                            )
                        })
                    :
                        variables.historial.map((v, i) => {
                            return (
                                <div className='class'>
                                    <Link to={"/controlpanel/assistances/info/reg"} state={{
                                        regId: v.id,
                                        ref: ref,
                                        id: id,
                                        regRef: variables.regRef,
                                        academia: academia
                                    }} className='contInfo'>
                                        <p style={{
                                            fontFamily: fontType.title
                                        }} className='nombre'>{v.nombre_clase}</p>
                                        <p style={{
                                            fontFamily: fontType.text
                                        }} className='fecha'>{v.fecha_clase} | {v.hora_clase}</p>
                                    </Link>
                                </div>
                            )
                        })
                }

            </div>

        </div>
    )
}

export default AssistancesInfo